module.exports = __webpack_public_path__ + "img/illustrations-fail.6040797b.svg";